import Post from "../entities/post/Post.js";

export default class PostRepository {
    #httpClient;
    #endpointUrl;

    constructor(httpClient, endpointUrl = '/api/post') {
        this.#httpClient = httpClient;
        this.#endpointUrl = endpointUrl;
    }

    /**
     * {string} teamId
     * @returns {Promise<Post>}
     */
    async getPost(postId) {
        const response = await this.#httpClient
            .fetch(`${this.#endpointUrl}/${postId}`, {
                method: 'GET',
                headers: {
                    "Accept": "application/json"
                },
                responseType: 'json'
            });
        return Post.parseServerJson(response)
    }

    /**
     * {string} orgId
     * @returns {Promise<Post[]>}
     */
    async getPostList(orgId) {
        const response = await this.#httpClient
            .fetch(`${this.#endpointUrl}?orgId=${orgId}`, {
                method: 'GET',
                headers: {
                    "Accept": "application/json"
                },
                responseType: 'json'
            });
        return Post.parseServerJsonMany(response)
    }

    /**
     * @param {string} orgId
     * @param {string} postTitle
     * @param {string} postBody
     * @returns {Promise<Post>}
     */
    async createPost(orgId, postTitle, postBody){
        const response = await this.#httpClient
            .fetch(`${this.#endpointUrl}?orgId=${orgId}`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json"
                },
                responseType: 'json',
                body: JSON.stringify({title: postTitle, body: postBody}),
            });
        return Post.parseServerJson(response)
    }

    /**
     * @param {string} postId
     * @param {string} postTitle
     * @param {string} postBody
     * @returns {Promise<Post>}
     */
    async updatePost(postId, postTitle, postBody){
        await this.#httpClient
            .fetch(`${this.#endpointUrl}/${postId}`, {
                method: 'PUT',
                headers: {
                    "Content-Type": "application/json"
                },
                responseType: 'json',
                body: JSON.stringify({title: postTitle, body: postBody}),
            });
    }

    /**
     * @param {string[]} postIds
     * @returns {Promise<*>}
     */
    async deletePosts(postIds){
        return this.#httpClient.fetch(`${this.#endpointUrl}?id=` + `${postIds.join(',')}`, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json"
            },
            responseType: 'json'
        });
    }
}
